import request from '@/utils/request'

/** 优惠券来源：门店 / 总部 */
export const COUPON_SOURCE = {
  STORE: 'STORE',
  HEADQUARTERS: 'HEADQUARTERS',
}

/** pay / queryCalc 返回这些码时，需刷新总部优惠券并重算（不刷门店券） */
export const HQ_COUPON_REFRESH_CODES = [4007012, 4007016, 4007021, 4007022, 4006145]


/**
 * 获取会员积分
 * @param {*} data
 * @returns
 */
export function getMemberCouponList(data) {
  return request({
    url: '/mg/daohang-promotion-api/coupon/list',
    method: 'post',
    data,
  })
}

/**
 * 获取会员优惠券命中
 * @param {*} data
 * @returns
 */
export function getMemberMatchCouponList(data) {
  return request({
    url: '/mg/daohang-promotion-api/couponTemplate/isCouponHitted',
    method: 'post',
    data,
  })
}

/**
 * 将总部券字段对齐门店券，并打上来源标记
 * @param {Object} coupon
 * @returns {Object|null}
 */
export function normalizeHeadquartersCoupon(coupon) {
  if (!coupon) return null
  const couponCode = coupon.couponCode
  return {
    ...coupon,
    couponTemplateCode: couponCode,
    couponTemplateName: coupon.activityName || coupon.displayName || coupon.couponDisplay,
    couponTemplateType: 'FULL_REDUCTION',
    minPrice: coupon.thresholdAmt,
    discountPrice: coupon.rebateAmt,
    couponItems: coupon.couponItems || [],
    workDate: coupon.activityBegin,
    expireDate: coupon.activityEnd,
  }
}

/**
 * 总部优惠券命中，返回数组有值即命中
 * @param {Object} data - { memberNum, memberCode, phone, items, receivableAmt }
 * @returns {Promise}
 */
export function getHeadquartersCouponMatch(data) {
  // 赠品不参与总部券命中，过滤后再组装 sku 金额
  const items = (data?.items || [])
    .filter((item) => !item.ifGift)
    .map((item) => ({
      skuCode: item.skuCode || '',
      skuAmt: BN.times(item.packageRetailPrice || 0, item.packageQty || 0).toNumber(),
    }))
  // 收银页传 null；结算页传最新应收；未传时兜底 0
  const receivableAmt = data.receivableAmt === undefined ? 0 : data.receivableAmt
  return request({
    url: '/mg/daohang-order-api/headquartersCoupon/hit',
    method: 'post',
    data: {
      ...data,
      items,
      receivableAmt,
    },
  })
}
